import styled from 'styled-components';
import { STANDARD_HEADER_TOP_MARGIN } from '../utils/spacing';
import H4 from 'UIComponents/elements/headings/H4';
import MdxHeader from './MdxHeader';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledH4 = styled(H4).withConfig({
  displayName: "MdxH4__StyledH4",
  componentId: "n1hak5-0"
})(["margin-top:", ";"], STANDARD_HEADER_TOP_MARGIN);
function MdxH4(props) {
  return /*#__PURE__*/_jsx(MdxHeader, Object.assign({
    Component: StyledH4
  }, props));
}
export default MdxH4;